import React, { useState } from "react";
import "./Education.css";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

function Education() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleOpen = (index) => {
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setSelectedIndex(null);
  };

  const educationData = [
    {
      institution: "Loyola Marymount University",
      degree: "Bachelor of Science in Computer Science",
      year: "Aug. 2022 - May 2026",
      description:
        "Studied algorithms, data structures, artificial intelligence, formal languages and automata, web and mobile app development, operating systems, computer graphics, logic and digital design. Won the Git Gud Programming Competition.",
    },
    {
      institution: "TUMO Center for Creative Technologies",
      degree: "Advanced Computer Science Program",
      year: "Sep. 2016 - Sep. 2020",
      description:
        "Developed skills in web development, robotics, and game development. Later served as a programming lab assistant, mentoring and assisting over 100 students in their learning and projects.",
    },
  ];

  return (
    <div className="InfoComponent">
      <h1 className="education-intro">EDUCATION 📚</h1>
      <div className="education-container">
        {educationData.map((edu, index) => (
          <div
            key={index}
            className="education-item"
            onClick={() => handleOpen(index)}
          >
            <h2 className="education-institution">{edu.institution}</h2>
            <p className="education-degree">{edu.degree}</p>
            <p className="education-year">
              <AccessTimeIcon />
              {edu.year}
            </p>
          </div>
        ))}
      </div>

      <Modal open={selectedIndex !== null} onClose={handleClose}>
        <Box className="education-description-container">
          {selectedIndex !== null && (
            <>
              <button onClick={handleClose} className="close-icon">
                <CloseIcon />
              </button>
              <h2 className="education-institution">
                {educationData[selectedIndex].institution}
              </h2>
              <p className="education-degree">
                {educationData[selectedIndex].degree}
              </p>
              <p className="education-year">
                <AccessTimeIcon />
                {educationData[selectedIndex].year}
              </p>
              <p className="education-description">
                {educationData[selectedIndex].description}
              </p>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default Education;
